// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"Results_mainContent__OcIkq"};